module.exports = __webpack_public_path__ + "img/video_game_genres_splash.64b9907b.jpg";